module.exports = __webpack_public_path__ + "static/media/19264477_1109091819194329_2438596184312317223_o.f03d5187.jpg";